<template>
  <div class="bg-white dark:bg-gray-900">
    <AppHeader />
    <slot />
    <AppFooter />
    <FloatingControls />
    <CalComModal />
  </div>
</template>
